import $ from 'jquery';
import axios from 'axios';
import {API_URL} from './constants';
import { Redirect } from 'react-router-dom';
import { createElement } from 'react';

export const formatLimitString=(texto, size)=>
{
    try {
        if (texto===null) return '';
        if (texto.length>size)
        {
            return texto.substring(0, size) + '...'
        } else 
        {
            return texto;
        }
    } catch (ex)
    {
        return "";
    }
}

export const ValidateState=(formData, nameElement, valueValidate)=> 
{
    var list = JSON.parse(JSON.stringify(formData));
    if (list[nameElement] === null || list[nameElement] === undefined) { return true; }
    return ((list[nameElement].toString()===valueValidate))
} 

export const ValidateArrayState = (formData, nameElement, valueValidate)=> 
{
    var list = JSON.parse(JSON.stringify(formData));

    if ((Array.isArray(list[nameElement]) && list[nameElement].length <= 0) || list[nameElement] === null || list[nameElement] === undefined || list[nameElement] === "0" || list[nameElement] === 0 || list[nameElement] === "") { 
      return true; 
    }
    return ((list[nameElement].toString() === valueValidate))
} 

export const distinct = (value, index, self) => { return self.indexOf(value)===index;}

export const getRoles = (arr) => {
    return arr.cRolesxUsuario.filter(option=> { return option.cRoles.nTipSistema === "4650"; });
}

export const getPermissions=(arr)=>
{
    var settings = [];
    var temp = getRoles(arr).map((item)=> { settings.push(item.cRoles.nRolCantidadPermisos);});
    settings=settings.filter(distinct);
    return settings;
}

export const GetMenuHeader = (array, exceptGroup = "AprobacionCertificacionesPortal") => {
    var settings = [];
    var returnArray  = [];

    var temp = array.map((item)=> { 
      if(exceptGroup !== ""){
        if(item.sAgrupador !== exceptGroup)
        {
          settings.push(item.sAgrupador);
        }
      }else{
        settings.push(item.sAgrupador);
      }
      
    });

    settings=settings.filter(distinct);

    temp = settings.map((item)=> {

        var op, it = {};
        var itArray = []; 

        array.map((opt)=> {
            if (opt.sAgrupador===item) 
            { 
                it = {sOpcNombre: opt.sOpcNombre, sUrl: opt.sUrl}
                itArray.push(it);
            }
        });    

        op = {sAgrupador: item, sMenu: itArray};

        returnArray.push(op)
    });

    
    return returnArray;
}

export const approveRole = (filter, isSuperAdmin = false) => {
    if(!isSuperAdmin){
      for(var fil in filter) {
          if (filter[fil].cRoles.sRolDescripcion.toString() === "998") {
              return true;
          }
      }
      return false;
    }else{
      return isSuperAdmin;
    }
}

export const filterOptions = (arr, filter) =>
{
    var optionZero = { value: 0, label: 'Seleccione una Opción de la Lista'};
    var ArrayRetorno = [];
    ArrayRetorno.push(optionZero);

    for(var fil in filter) {

        if (filter[fil].cRoles.sRolDescripcion.toString()==="998") { return arr; }

        if (filter[fil].cRoles.sRolDescripcion.toString()!=="999") {
            for(var item in arr) {
                if (filter[fil].cRoles.sRolDescripcion.toString()===arr[item].value.toString())
                {
                    ArrayRetorno.push(arr[item]);
                }
            }
        } else 
        {
            ArrayRetorno = arr;
        }
     }
     
    return ArrayRetorno;
}

export const GenerateArrayToDropDown=(arr)=>
{
    var optionZero = { value: 0, label: 'Seleccione una Opción de la Lista'};
    var ArrayRetorno = [];
    
    ArrayRetorno.push(optionZero);

    for(var item in arr) {
        ArrayRetorno.push(arr[item]);
     }
    return ArrayRetorno;
}

export const GenerateArrayToDropDownWithoutZeroOpt = (arr) =>
{
  return arr;
}

/// Functions for JSON array
export const deleteItemArray=(array, name, key)=>{
    var list = JSON.parse(JSON.stringify(array));
    return list.filter(item=> { return item[name]!==key; });
}

export const findItemArray=(array, name, key)=>{
    var list = JSON.parse(JSON.stringify(array));
    return list.filter(item=> { return item[name]===key; });
}

export const addItemArray=(array, item)=>{
    var list = JSON.parse(JSON.stringify(array));
    var element = JSON.parse(JSON.stringify(item));
    list.push(element);
    return list;
}

export const updateItemArray=(array, name, key, item)=>{
    var list = deleteItemArray(array, name, key);
    var returnList = addItemArray(list, item);
    return returnList;
}

export const updateValueInItemArray=(array, key, value, field, change)=>
{
    var list = JSON.parse(JSON.stringify(array));
    var item = list.find(x => x[key] === value);
    if (item) item[field] = change;
    console.log(list);
    return list;
}

export const updateValueInJson =(object, key, value)=>
{
    var obj = JSON.parse(JSON.stringify(object));
    if (obj) obj[key] = value;
    return obj;
}

/// ------------------------------

/// General functions

export const formatDate=(date, format) => {
    var newDate = new Date(date);
    console.log(newDate);
}

export const setTextInputLongitud = (ids) => {

  for(var i = 0; i < ids.length; i++){
    let id = ids[i];
    let txt = document.getElementById(id);
    let maxLength = txt.maxLength;
    let longitudField = 'longitud' + id;
    document.getElementById(longitudField).textContent = txt.value.length + '/' + maxLength;
    txt.setAttribute("data-longitud-id", longitudField);
    txt.addEventListener('keyup', function (event){
        let actualLength = this.value.length;
        let longitudField = this.getAttribute('data-longitud-id');
        document.getElementById(longitudField).textContent = actualLength + '/' + maxLength;
    });
  }
}

export const arrayObjectToValue = (array, keyValue) => {
  let newArray = [];

  array.forEach(function (item){
    newArray.push(item[keyValue]);
  })

  return newArray;
}

export const generateSlugAutomatico = (titulo) => {

  function replaceAll(str, find, replace)
	{
		return str.replace(new RegExp(find, 'g'), replace);
	}

  let url2 = titulo.toLowerCase();
  let url3 = replaceAll(url2, " ","-");
  let url4 = replaceAll(url3, "á","a");
  let url5 = replaceAll(url4, "é","e");
  let url6 = replaceAll(url5, "í","i");
  let url7 = replaceAll(url6, "ó","o");
  let url8 = replaceAll(url7, "ú","u");
  let url9 = replaceAll(url8, "ñ","n");
  let url10 = replaceAll(url9, "@","");

  return url10;
}


export const loadingButton=(buttonCode, classIcon)=>
{
    var elementButton = document.getElementById("btn_" + buttonCode);
    var elementIcon = document.getElementById("i_" + buttonCode);

    elementButton.setAttribute("disabled","disabled");

    elementIcon.classList.remove(classIcon);
    elementIcon.classList.add("fa-refresh");
    elementIcon.classList.add("fa-spin");
}

export const loadingButtonEnd=(buttonCode, classIcon, disabled=true)=>
{
    var elementButton = document.getElementById("btn_" + buttonCode);
    var elementIcon = document.getElementById("i_" + buttonCode);

    if (disabled){
        elementButton.classList.remove("btn-primary");
        elementButton.classList.add("btn-default");
        elementButton.removeAttribute("disabled");
    }

    elementIcon.classList.remove("fa-refresh");
    elementIcon.classList.remove("fa-spin");
    elementIcon.classList.add(classIcon);
}


export const fileToBase64 = (filename, filepath) => {
    return new Promise(resolve => {
      var file = new File([filename], filepath);
      var reader = new FileReader();
      // Read file content on file loaded event
      reader.onload = function(event) {
        resolve(event.target.result);
      };
      
      // Convert data to base64 
      reader.readAsDataURL(file);
    });
  };

  export const toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
});

export const showModalEditMenu = (e) => {    
    $(".divInteligenciaComercial").fadeIn();  
};

export const showModalPaginas = (e) => { 
    e.preventDefault();   
    $(".divModalPaginas").fadeIn();  
};

export const showCreateGlosario = (e) => { 
    e.preventDefault();   
    $("#btnCreateGlosario").fadeOut(); 
    $("#containerFormCreate").fadeIn();  
};

export const showEditGlosario = (e) => { 
    e.preventDefault();   
    $("#btnCreateGlosario").fadeOut();
    $("#containerFormUpdate").fadeIn();  
};

export const cancelFormularioGlosario = (e) => { 
    e.preventDefault(); 
    $("#containerFormCreate").fadeOut();  
    $("#containerFormUpdate").fadeOut();  
    $("#btnCreateGlosario").fadeIn();  
};

export const stringToSlug = (str) =>
{
    str = str.replace(/^\s+|\s+$/g, "");
    str = str.toLowerCase();

    var from = "åàáãäâèéëêìíïîòóöôùúüûñç·/_,:;";
    var to = "aaaaaaeeeeiiiioooouuuunc------";

    for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
    }

    str = str
        .replace(/[^a-z0-9 -]/g, "")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-");

    return str;
}

export const hideNav = () => {
  $(".divContenidoPanelNav").animate({"left": "-510px"});
}

export const configureMoment = (Moment) => {
  Moment.updateLocale('en', {
      months : [
          "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio",
          "Agosto", "Setiembre", "Octubre", "Noviembre", "Diciembre"
      ]
  });

  Moment.updateLocale('en', {
      weekdays : [
          "Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"
      ]
  });
}

export const showLoader = () => {
  var bgLoader = document.createElement('div');
  var loader = document.createElement('div');
  
  bgLoader.classList.add('bg-loader');
  loader.classList.add('loader');

  bgLoader.append(loader);

  document.body.append(bgLoader);
}

export const hideLoader = () => {
  var bgLoader = document.querySelector('.bg-loader');
  if(bgLoader != null){
    bgLoader.remove();
  }
}

export const setTestData = () => {
  var items = document.querySelectorAll('.data-test');

  items.forEach(function (item){
      var data = item.getAttribute('placeholder');
      item.value = data;
  });
}

export const setDataForm = (dataForm) => {
  var items = document.querySelectorAll('.data-form');

  items.forEach(function (item){
      var id = item.getAttribute('id');
      dataForm[id] = item.value;
  });
}

export const cleanDataForm = () => {
  var items = document.querySelectorAll('.data-form');

  items.forEach(function (item){
      item.value = "";
  });
}
/* MODULOS WEB */

export const showModalModulosWeb = (e) => { 
    e.preventDefault();   
    $(".divModalModulos").fadeIn();  
};

export const showModalFormId = (id, e) => { 
    e.preventDefault();   
    $("#modal_" + id).fadeIn();  
};

export const showModalPageClass = (className = "divModalPagina") => {     
    $("." + className).fadeIn();  
};

export const hideModalPageClass = (className = "divModalPagina") => { 
    $("." + className).fadeOut();  
};

export const esUrl = (url = "") => { 

    var pattern = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;

    if (pattern.test(url)) {
        return true;
    } 

     return false;
};

export const GetMenuHeaderByGroup = (array, group = "") =>
{
    var settings = [];
    var returnArray  = [];

    var temp = array.map((item)=> { 
      if(item.sAgrupador == group){
          settings.push(item.sAgrupador);
      }                       
  });

    settings=settings.filter(distinct);

    temp = settings.map((item)=> {
        
        var op, it = {};
        var itArray = []; 

        array.map((opt)=> {
            if (opt.sAgrupador===item) 
            { 
                it = {sOpcNombre: opt.sOpcNombre, sUrl: opt.sUrl}
                itArray.push(it);
            }
        });    

        op = {sAgrupador: item, sMenu: itArray};

        returnArray.push(op)
        
    });

    return returnArray.length > 0 ? returnArray[0] : null;
}

export const existInObjectPermission = (array, sUrl = "", sAgrupador="") =>
{
    var settings = [];

    var temp = array.map((item)=> {         
        
        if(item.sUrl == sUrl && sAgrupador == ""){
            settings.push(item.sAgrupador);
        }
        
        if(item.sAgrupador == sAgrupador && sUrl == ""){
            settings.push(item.sAgrupador);
        }

    });
    return settings.length > 0 ? true : false;
}

export const validateUrl = (array, sUrl = "", sAgrupador="") =>
{
    let validate = existInObjectPermission(array, sUrl, sAgrupador);
    if(!validate){
        window.location="/";
    }    
}

export const validateAccesoGeneral = (objectState = null, sUrl = "", rol = 0) => {
    
    if( objectState !== null ){        
        return validateUrl(objectState.menuGeneral, sUrl);
    }else{

        const url = `${API_URL}MenuUX/${rol}`;

        axios.get(url).then(response => response.data)
        .then((data) => {

          let menuTemp = [{
            sAgrupador:"Administradores",
            sOpcNombre:"Menus",
            sUrl:"/menu"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Categorias de Certificaciones",
            sUrl:"/categorias-certificacion"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Categorías de Exporta Fácil",
            sUrl:"/categorias-exporta-facil"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Categorías de Preguntas Frecuentes",
            sUrl:"/categorias-faq"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Categorías de Herramientas de Análisis",
            sUrl:"/categorias-herramienta-analisis"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Categorías de Puede Interesarte",
            sUrl:"/categorias-puede-interesarte"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. de Páginas",
            sUrl:"/paginas"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. de H. de Análisis",
            sUrl:"/herramientas-analisis"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. de Certificaciones",
            sUrl:"/certificaciones"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. de Oficinas en el Mundo",
            sUrl:"/oficinas-mundo"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. También Puede Interesarte",
            sUrl:"/puede-interesarte"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. de Documentación para Exportar",
            sUrl:"/documento-exportacion"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. de Guías para el Exportador",
            sUrl:"/guia-exportador"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. de Categorías Potencial de Exportación",
            sUrl:"/categorias-potencial-exportador"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. Exporta Fácil",
            sUrl:"/exporta-facil"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. Productos Priorizados por Sector y Mercado",
            sUrl:"/productos-priorizado"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. de H. para Pymes",
            sUrl:"/herramientas-pyme"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. H. Externas",
            sUrl:"/herramientas-externa"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. de Programas de Capacitación",
            sUrl:"/programas-capacitacion"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. de Glosarios",
            sUrl:"/glosario"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. FAQ",
            sUrl:"/faqs"
          },
          {
            sAgrupador:"Usuarios",
            sOpcNombre:"Usuarios",
            sUrl:"/usuarios"
          },
          {
            sAgrupador:"Usuarios",
            sOpcNombre:"Roles",
            sUrl:"/perfiles"
          },
          {
            sAgrupador:"Reportes",
            sOpcNombre:"Encuestas",
            sUrl:"/reporte-encuesta"
          },
          {
            sAgrupador:"Reportes",
            sOpcNombre:"Logs",
            sUrl:"/reporte-logs"
          },
          {
            sAgrupador:"Reportes",
            sOpcNombre:"Suscriptor",
            sUrl:"/reporte-suscriptor-footer"
          },
          {
            sAgrupador:"Reportes",
            sOpcNombre:"Trazabilidad",
            sUrl:"/reporte-trazabilidad"
          },
          {
            sAgrupador:"Configuradores",
            sOpcNombre:"Panel de Configuración",
            sUrl:"/configuradores"
          }]

          menuTemp.map((menu) => (
            data.result.push(menu)
          ))
      
          var menuGeneral = data.result;

          validateUrl(menuGeneral, sUrl); 
      })
      .catch(error => {
          console.log(error);
      });
    }   
}


